

if (typeof WDN === "undefined") {
  var WDN = {};
}

if (typeof WDN.RenderTemplate === "undefined") {
  WDN.RenderTemplate = (function () {
    var Query, _generateQueryUrl, _sendRequest, validate, clearLoading;
    var setLoadingState;
    Query = function (obj) {
      if (validate(obj)) {
        var output = document.querySelector(obj.target);
        if (output) {
          setLoadingState(output);
          var link = obj.url;
          // if it's object, we are generating product search query url
          if (typeof obj.url === "object") {
            link = _generateQueryUrl(obj);
          }
          _sendRequest(link, output, obj.callback, obj.replace);
        }
      } else {
        console.warn("Missing parameters for WDN.RenderTemplate");
      }
    };
    setLoadingState = function (target) {
      target.setAttribute("data-loading", "");
    };

    validate = function (obj) {
      return !!(obj.url && obj.target);
    };

    clearLoading = function (target) {
      target.removeAttribute("data-loading");
    };

    _sendRequest = function (url, target, callback, replace) {
      WDN.Request.Get({
        url: url,
        onSuccess: function (res) {
          // success callback
          clearLoading(target);
          if (replace) {
            target.innerHTML = res;
          } else {
            target.insertAdjacentHTML("beforeend", res);
          }
          typeof callback === "function" ? callback() : "";
        },
        onError: function (res) {
          // error callback
          console.log("error");
        },
      });
    };

    _generateQueryUrl = function (obj) {
      var url = "/search?view=" + obj.template + "&type=product&q=id:" + obj.url.join("%20OR%20id:");

      return url;
    };

    return Query;
  })();
}

if (typeof WDN.State === "undefined") {
  WDN.State = (function () {
    var config = {
      open: "open",
      closed: "closed",
    };
    return {
      open: function () {
        this.dataset.state = config.open;
      },
      close: function () {
        this.dataset.state = config.closed;
      },
      get: function () {
        return this.dataset.state;
      },
    };
  })();
}

if (typeof WDN.Select === "undefined") {
  WDN.Select = (function () {
    var State = WDN.State;
    var Select;

    // Glob list to hold our selects on page
    var List = {};
    var Create;

    var Config = {
      select: "Select",
      active: "Select__option--active",
      label: "Select__label",
      option: "Select__option",
      trigger: "Select__trigger",
      current_label: "[data-current-label]",
    };

    // Factory function
    Select = function (id) {
      this.id = id;
      var _this = this;

      this.selectors = {
        body: `body`,
        select: `.${Config.select}[data-id='${this.id}']`,
        options: `.${Config.select}[data-id='${this.id}'] .${Config.option}`,
        trigger: `.${Config.select}[data-id='${this.id}'] .${Config.trigger}`,
        label: `.${Config.select}[data-id='${this.id}'] .${Config.label}`,
        current_label: `.${Config.select}[data-id='${this.id}'] ${Config.current_label}`,
      };

      // Cache nodes
      this.nodes = {
        body: document.querySelector(this.selectors.body),
        select: document.querySelector(this.selectors.select),
        options: document.querySelectorAll(this.selectors.options),
        trigger: document.querySelector(this.selectors.trigger),
        label: document.querySelectorAll(this.selectors.label),
        current_label: document.querySelector(this.selectors.current_label),
      };

      this.target = this.nodes.select;

      this.currentOption = {};
      this.allOptions = {};

      // Build all options
      Array.from(this.nodes.options).map(function (option) {
        var obj = {
          label: option.innerText.trim(),
          value: option.dataset.value,
        };

        _this.allOptions[obj.value] = obj;
      });

      var Values = Array.from(this.nodes.options).map(function (elem) {
        return elem.dataset.value;
      });

      // Setup intial state

      var InitialActive = this.nodes.select.querySelector(`.${Config.active}`);
      this.currentOption = this.allOptions[InitialActive.dataset.value];
      this.value = this.currentOption.value;
      this.nodes.current_label.innerText = this.currentOption.label;

      // Select DOM element
      this.setActive = function (option) {
        // Deselect previous value
        var prevActive = this.nodes.select.querySelector(`.${Config.active}`);
        prevActive.classList.remove(Config.active);

        this.updateCurrent(option);
        option.classList.add(Config.active);
      };

      this.updateCurrent = function (option) {
        var item = this.nodes.trigger;
        item.querySelector(this.selectors.label).innerText = this.currentOption.label;
        item.dataset.value = this.currentOption.value;
      };

      this.isValidOption = function (value) {
        if (Values.indexOf(value) > -1) {
          return true;
        }
      };

      this.update = function (value) {
        // Close only if interacted by user
        if (event) {
          this.close();
        }
        // Check if we were provided a valid option value
        // Check if the value is not already selected

        if (this.isValidOption(value) && this.value !== value) {
          // Find our selected option based on value parameter
          var option = this.target.querySelector(`.${Config.option}[data-value="${value}"]`);

          // Update interal value of select
          this.currentOption = this.allOptions[value];
          this.value = this.currentOption.value;

          // Update DOM
          this.setActive(option);

          // If a callback was provided, lets call it
          if (this.callback) {
            this.callback.call(this);
          }
        }
      };

      // Event listener functions
      this.onBlur = function () {
        this.close();
      };

      this.onEscape = function () {
        if (event.keyCode == 27) {
          this.close();
        }
      };

      // Named functions, to add / remove
      this.onBlurWrap = this.onBlur.bind(this);
      this.onEscapeWrap = this.onEscape.bind(this);

      // Short hand functions to add / remove
      this.addListeners = function () {
        this.target.focus();
        this.target.addEventListener("blur", this.onBlurWrap);
        window.addEventListener("keyup", this.onEscapeWrap);
      };

      this.removeListeners = function () {
        this.target.removeEventListener("blur", this.onBlurWrap);
        window.removeEventListener("keyup", this.onEscapeWrap);
      };

      // Register clicks on open/close Select
      this.nodes.trigger.addEventListener("click", this.toggle.bind(this));

      // Register clicks on Select options
      this.nodes.options.forEach(function (option) {
        option.addEventListener("click", function () {
          _this.update(option.dataset.value);
        });
      });
    };

    Select.prototype.open = function () {
      State.open.call(this.target);
      this.addListeners();
    };

    Select.prototype.close = function () {
      State.close.call(this.target);
      this.removeListeners();
    };

    Select.prototype.state = function () {
      return State.get.call(this.target);
    };

    Select.prototype.toggle = function () {
      if (this.state() === "closed") {
        this.open();
      } else {
        this.close();
      }
    };

    Create = function (id) {
      if (!List[id] && id && document.querySelector(`.${Config.select}[data-id='${id}']`)) {
        List[id] = new Select(id);
      } else {
        console.warn(`Failed to init new Select with ID: "${id}".`);
      }
    };

    var Init = function () {
      document.querySelectorAll(`.${Config.select}`).forEach(function (select) {
        if (select.dataset.id) {
          Create(select.dataset.id);
        }
      });
    };

    return {
      Create: Create,
      List: List,
      Init: Init,
    };
  })();
}

if (typeof WDN.Product_select === "undefined") {
  WDN.Product_select = (function () {
    var Names = {
      selectScript: "Select__product-script",
      selectParent: "Select__variants",
      selectItem: "Select__variants-item",

      variantSelect: "Variant__select",
      variantOption: "Drawer__option",
      variantSelectLabel: "Variant__select-label span",
      price: "data-product-price",
      priceCompare: "data-product-compare-price",
      submit: "data-add-to-cart",
    };

    var Selectors = {
      selectScript: `.${Names.selectScript}`,
      selectParent: `.${Names.selectParent}`,
      selectItem: `.${Names.selectItem}`,

      variantSelect: `.${Names.variantSelect}`,
      variantOption: `.${Names.variantOption}`,
      variantSelectLabel: `.${Names.variantSelectLabel}`,
      price: `[${Names.price}]`,
      priceCompare: `[${Names.priceCompare}]`,
      submit: `[${Names.submit}]`,
    };

    var Nodes = {
      selectScript: document.querySelector(Selectors.selectScript),
      selectParent: document.querySelector(Selectors.selectParent),

      price: document.querySelector(Selectors.price),
      priceCompare: document.querySelector(Selectors.priceCompare),
      submit: document.querySelector(Selectors.submit),

      variantSelect: document.querySelector(Selectors.variantSelect),
      variantOptions: document.querySelectorAll(Selectors.variantOption),
      variantSelectLabel: document.querySelector(Selectors.variantSelectLabel),
    };

    var Config = {};

    // Pub
    var Init;

    var InitDropdowns, InitDrawerSelect, UpdateUrl;

    // global var
    var Reference, Ids;

    var Product = {};

    var Variant = {};

    // save and store ids from dropdowns
    Variant.storeIds = function () {
      var items = Nodes.selectParent.querySelectorAll(Selectors.selectItem);
      Ids = [];
      items.forEach(function (item) {
        Ids.push(item.dataset.id);
      });
    };

    // creates references for all dropdowns
    Variant.createReference = function () {
      SelectedVariant = [];
      Reference = Ids.map(
        function (id) {
          var singleSelect = WDN.Select.List[id];

          singleSelect.callback = function () {
            Variant.onVariantChange(Variant.find());
          };

          return singleSelect;
        }.bind(this)
      );
    };

    Variant.updatePrice = function () {
      if (this.variant) {
        if (Nodes.price) {
          Nodes.price.innerHTML = WDN.Money.Format(this.variant.price);
        }
        if (Nodes.priceCompare) {
          if (this.variant.compare_at_price > this.variant.price) {
            Nodes.priceCompare.innerHTML = WDN.Money.Format(this.variant.compare_at_price);
          } else {
            Nodes.priceCompare.innerHTML = "";
          }
        }
      }
    };

    Variant.setButtonState = function () {
      if (Nodes.submit) {
        if (this.variant && this.variant.available) {
          Nodes.submit.disabled = false;
        } else {
          Nodes.submit.disabled = true;
        }
      }
    };

    Variant.onVariantChange = function (variant) {
      this.variant = variant;
      Config.onChange ? Config.onChange(variant) : "";
      this.updatePrice();
      this.setButtonState();
      variant ? UpdateUrl(variant.id) : "";
    };

    // gets all selected variants
    Variant.getCurrent = function () {
      return Reference.map(function (option) {
        return option.currentOption.value;
      });
    };

    // finds selected variant
    Variant.find = function (name) {
      var variants = Product.get().variants;
      if (variants) {
        var selected;
        if (name) {
          selected = JSON.stringify(name);
        } else {
          selected = JSON.stringify(Variant.getCurrent());
        }
        var found = false;
        variants.forEach(function (variant) {
          var productVariant = JSON.stringify(variant.options);
          if (productVariant == selected) {
            found = variant;
          }
        });
      }
      return found;
    };

    UpdateUrl = function (id) {
      //window.history.pushState('', '', `?variant=${id}`);
    };

    // returns product object
    Product.get = function () {
      if (!Nodes.selectScript) {
        return false;
      }

      return JSON.parse(Nodes.selectScript.innerText)[0];
    };

    var VariantSingle = {};

    if (WDN.Drawer) {
      var Drawer = WDN.Drawer.List.variant_drawer;
    }

    // List to store different variant options inside sidebar
    VariantSingle.list = {};

    VariantSingle.init = function () {
      this.bindSelect();
      this.createInstance();
    };

    // Open the drawer when clicked on the pseudo select trigger
    VariantSingle.bindSelect = function () {
      Nodes.variantSelect.addEventListener("click", VariantSingle.selectOnClick);
    };

    // Actions on pseudo dropdown select
    VariantSingle.selectOnClick = function () {
      Drawer.open();
    };

    VariantSingle.createInstance = function () {
      if (Nodes.variantOptions.length > 0) {
        Nodes.variantOptions.forEach(function (option) {
          if (option.dataset.outOfStock !== "") {
            var newObj = new Option(option.dataset.id);
            VariantSingle.list[option.dataset.id] = newObj;
          }
        });
      }
    };

    // Create instance for each option in variant dropdowm
    var Option = function (id) {
      this.id = id;
      this.option = document.querySelector(`${Selectors.variantOption}[data-id="${id}"]`);
      this.title = this.option.dataset.title;
      this.isSelected = false;
      this.bind();
    };

    Option.prototype.bind = function () {
      this.option.addEventListener("click", this.optionOnClick.bind(this));
    };

    Option.prototype.optionOnClick = function () {
      this.clearSelected();
      this.isSelected = true;
      this.updateDom();
      this.callback();
      Drawer.close();
    };

    Option.prototype.callback = function () {
      if (Config && Config.onChange) {
        var selectedVariant = [];
        selectedVariant.push(this.title);
        var variant = Variant.find(selectedVariant);
        Variant.onVariantChange(variant);
      }
    };

    Option.prototype.clearSelected = function () {
      for (var key in VariantSingle.list) {
        if (VariantSingle.list.hasOwnProperty(key)) {
          VariantSingle.list[key].isSelected = false;
          VariantSingle.list[key].clearHiglight();
        }
      }
    };

    Option.prototype.updateDom = function () {
      this.higlight();
      this.updateLabel();
    };

    Option.prototype.higlight = function () {
      this.option.setAttribute("data-selected", "");
    };

    Option.prototype.clearHiglight = function () {
      this.option.removeAttribute("data-selected");
    };

    Option.prototype.updateLabel = function () {
      Nodes.variantSelect.dataset.id = this.id;
      Nodes.variantSelectLabel.innerHTML = this.title;
    };

    InitDropdowns = function (obj) {
      Nodes.selectParent = document.querySelector(Selectors.selectParent);
      Nodes.selectScript = document.querySelector(Selectors.selectScript);
      if (Nodes.selectParent) {
        Variant.storeIds();
        //### set callback on config
        Variant.createReference(obj);
        if (obj) {
          if (obj.onLoad) {
            obj.onLoad(Variant.find());
          }

          if (obj.onChange) {
            Config.onChange = obj.onChange;
          }
        }
      }
    };

    InitDrawerSelect = function (obj) {
      if (Nodes.variantSelect) {
        VariantSingle.init();
        if (obj) {
          Config.onChange = obj.onChange;
          if (obj.onLoad) {
            var selected = document.querySelector(`${Selectors.variantOption}[data-selected]`);
            var selectedTitle = [];
            selected ? selectedTitle.push(selected.dataset.title) : false;
            obj.onLoad(Variant.find(selectedTitle));
          }
        }
      }
    };

    Init = function (obj) {
      InitDropdowns(obj);
      InitDrawerSelect(obj);
    };

    return {
      Init: Init,
    };
  })();
}

if (typeof WDN.Money === "undefined") {
  WDN.Money = (function () {
    var FormatMoney = function (price) {
      return theme.Currency.formatMoney(price, theme.moneyFormat);
    };

    return {
      Format: FormatMoney,
    };
  })();
}

if (typeof WDN.Helpers === "undefined") {
  WDN.Helpers = (function () {
    // pub
    var Debounce;

    Debounce = function (Function, WaitTime) {
      // Named function to start / clear timer
      var Timer;
      return function () {
        var This = this,
          args = arguments;
        var later = function () {
          Timer = null;
          Function.apply(This, args);
        };
        clearTimeout(Timer);
        Timer = setTimeout(later, WaitTime);
      };
    };

    return {
      Debounce: Debounce,
    };
  })();
}

if (typeof WDN.Poster === "undefined") {
  WDN.Poster = (function () {
    var Names = {
      sidebarAdd: "Poster__grid-button--add",
      background: "Poster__grid-background",
      backgroundToggle: "Poster__background-button",
      price: "Poster__footer-price",
      paginationPrevious: "Poster__paginate-previous",
      paginationNext: "Poster__paginate-next",
      sidebarGrid: "Poster__sidebar-collecton--grid",
      frameDrawer: "Poster__drawer-content",
      addToCart: "Poster__footer",
      wishlist: "Poster__navigation-wishlist",
      wishlistGrid: "Poster__sidebar-wishlist--grid",
      sidebarItems: "Poster__sidebar-content--item",
      navSelect: "Poster__navigation-select",
      frameContainer: "Poster__drawer-frame--image",
      searchInput: "Poster__navigation-search--input",
      searchGrid: "Poster__sidebar-search--grid",
      previewFrame: "Poster__preview-frame",
      previewPassepartout: "Poster__preview-passepartout",
      productGridItem: "Poster__product--grid",
      sidebar: "Poster__sidebar",
      dataHidden: "data-hidden",
      miniCartWrapper: "Poster__miniCart",
      miniCartCount: "data-minicart-count",
      miniCartItems: "data-minicart-items",
      miniCartArrow: "data-minicart-arrow",
      miniCartContainer: "data-minicart-container",
    };
    var Selectors = {
      sidebarAdd: `.${Names.sidebarAdd}`,
      background: `.${Names.background}`,
      price: `.${Names.price}`,
      backgroundToggle: `.${Names.backgroundToggle}`,
      paginationPrevious: `.${Names.paginationPrevious}`,
      paginationNext: `.${Names.paginationNext}`,
      sidebarGrid: `.${Names.sidebarGrid}`,
      frameDrawer: `.${Names.frameDrawer}`,
      addToCart: `.${Names.addToCart}`,
      wishlist: `.${Names.wishlist}`,
      wishlistGrid: `.${Names.wishlistGrid}`,
      sidebarItems: `.${Names.sidebarItems}`,
      navSelect: `.${Names.navSelect}`,
      frameContainer: `.${Names.frameContainer}`,
      searchInput: `.${Names.searchInput}`,
      searchGrid: `.${Names.searchGrid}`,
      previewFrame: `.${Names.previewFrame}`,
      previewPassepartout: `.${Names.previewPassepartout}`,
      productGridItem: `.${Names.productGridItem}`,
      sidebar: `.${Names.sidebar}`,
      miniCartWrapper: `.${Names.miniCartWrapper}`,
      miniCartCount: `[${Names.miniCartCount}]`,
      miniCartItems: `[${Names.miniCartItems}]`,
      miniCartArrow: `[${Names.miniCartArrow}]`,
      miniCartContainer: `[${Names.miniCartContainer}]`,
    };
    var Nodes = {
      background: document.querySelector(Selectors.background),
      price: document.querySelector(Selectors.price),
      backgroundToggle: document.querySelector(Selectors.backgroundToggle),
      sidebarGrid: document.querySelector(Selectors.sidebarGrid),
      frameDrawer: document.querySelector(Selectors.frameDrawer),
      addToCart: document.querySelector(Selectors.addToCart),
      wishlist: document.querySelector(Selectors.wishlist),
      wishlistGrid: document.querySelector(Selectors.wishlistGrid),
      sidebarItems: document.querySelectorAll(Selectors.sidebarItems),
      navSelect: document.querySelector(Selectors.navSelect),
      searchInput: document.querySelector(Selectors.searchInput),
      searchGrid: document.querySelector(Selectors.searchGrid),
      sidebar: document.querySelector(Selectors.sidebar),
      miniCartWrapper: document.querySelector(Selectors.miniCartWrapper),
      miniCartCount: document.querySelector(Selectors.miniCartCount),
      miniCartItems: document.querySelector(Selectors.miniCartItems),
      miniCartArrow: document.querySelector(Selectors.miniCartArrow),
      miniCartContainer: document.querySelector(Selectors.miniCartContainer),
    };

    var Bind = {};

    var Posters = {};

    var Init,
      CreatePoster,
      InsertInPoster,
      HideCategories,
      CreateInstance,
      Poster,
      RenderWishlistData,
      UpdatePrice,
      DrawerAdjust,
      UpdateUrl,
      SelectHandler,
      TemplateOption,
      _preloadImages;
    // handlers
    var SidebarAddHandler,
      SearchHandler,
      AddToCartHandler,
      BackgroundDrawerToggle,
      WishlistHandler,
      PaginationClickHandler;

    var RenderWishlistFramesAndPassepartouts,
      SelectSetPlaceholder,
      CollectItems,
      SetLoading,
      GetFrameById,
      ClearLoading,
      GetSelectedProduct;

    // last settings
    var LastUniqe, LastVariant, LastTopPos, LastLeftPos;

    var urlPrefix = "";

    // aug22 update

    var passePartoutJson = JSON.parse(document.querySelector("[data-passepartout-json]").innerText);

    var passepartoutImagesDump = JSON.parse(document.querySelector("[data-passepartout-images]").innerText);

    // aug22
    var _preloadPassepartouts = function () {
      var imageList = [];
      var srcList = [];
      passepartoutImagesDump.forEach(function (entry) {
        for (var key in entry.images) {
          if (entry.images.hasOwnProperty(key)) {
            var imageSrc = entry.images[key];
            if (srcList.indexOf(imageSrc) === -1) {
              var newImage = new Image();
              newImage.src = imageSrc;
              imageList.push(newImage);
              srcList.push(imageSrc);
            }
          }
        }
      });
    };

    // aug22
    var _preloadFrames = function () {
      var imageList = [];
      var srcList = [];

      for (var key in Frames) {
        if (Frames.hasOwnProperty(key)) {
          var variants = Frames[key].variants;

          for (var variant in variants) {
            if (variants.hasOwnProperty(variant)) {
              var images = variants[variant].images;

              for (var image in images) {
                if (images.hasOwnProperty(image)) {
                  var imageSrc = images[image];

                  if (srcList.indexOf(imageSrc) === -1) {
                    var newImage = new Image();
                    newImage.src = imageSrc;
                    imageList.push(newImage);
                    srcList.push(imageSrc);
                  }
                }
              }
            }
          }
        }
      }
    };

    _preloadImages = function () {
      _preloadPassepartouts();
      _preloadFrames();
    };

    var _getPassepartoutImageByVariantIdAndType = function (id, size) {
      var found = false;
      var size = size.replace("overlay_", "");
      passepartoutImagesDump.find(function (passepartout) {
        if (passepartout.id == id) {
          found = passepartout.images[size];
        }
      });

      return found;
    };

    var _getPassepartoutByVariantId = function (id) {
      var found = false;
      passePartoutJson.passepartout.find(function (item) {
        return item.variants.find(function (variant) {
          if (id == variant.id) {
            found = variant;
          }
        });
      });
      return found;
    };

    if (Shopify.locale != "en") {
      urlPrefix = "/" + Shopify.locale;
    }

    Bind.BackgroundToggle = function () {
      if (!Nodes.backgroundToggle) {
        return false;
      }

      Nodes.backgroundToggle.addEventListener("click", BackgroundDrawerToggle);
    };

    BackgroundDrawerToggle = function () {
      var drawer = WDN.Drawer.List["background"];
      drawer.onClose = function () {
        DrawerAdjust(this.drawer, "-100%");
      };
      if (drawer.state == "closed") {
        drawer.open();
        DrawerAdjust(drawer.drawer);
      } else {
        drawer.close();
        DrawerAdjust(drawer.drawer, "-100%");
      }
    };

    Bind.Sidebar = function () {
      var Buttons = document.querySelectorAll(Selectors.sidebarAdd);
      if (Buttons.length > 0) {
        Buttons.forEach(function (button) {
          button.addEventListener("click", SidebarAddHandler);
        });
        Bind.Pagination();
      }
    };

    Bind.Search = function () {
      Nodes.searchInput.addEventListener("keydown", WDN.Helpers.Debounce(SearchHandler, 600));
    };

    // ### UPDATE 2021
    Bind.MiniCart = function () {
      if (Nodes.miniCartArrow) {
        Nodes.miniCartArrow.addEventListener("click", miniCartArrowOnClick);
      }
    };
    // ### UPDATE 2021

    var miniCartArrowOnClick = function () {
      var wrapper = Nodes.miniCartWrapper;
      if (wrapper.dataset.minicart !== "0") {
        if (wrapper.dataset.minicartExpanded === "") {
          _collapseMiniCart();
        } else {
          _expandMiniCart();
        }
      }
    };
    // ### UPDATE 2021

    var _collapseMiniCart = function () {
      var wrapper = Nodes.miniCartWrapper;
      var container = Nodes.miniCartContainer;
      wrapper.removeAttribute("data-minicart-expanded");
      document.body.classList.remove("MiniCart--open");
      container.style.height = 0 + "px";
      _unbindWindowListener();
    };
    // ### UPDATE 2021

    var _expandMiniCart = function () {
      var wrapper = Nodes.miniCartWrapper;
      var container = Nodes.miniCartContainer;
      document.body.classList.add("MiniCart--open");
      wrapper.setAttribute("data-minicart-expanded", "");
      container.style.height = Nodes.miniCartItems.offsetHeight + "px";
      _listenForWindowClicks();
    };
    // ### UPDATE 2021

    var _listenForWindowClicks = function () {
      document.body.addEventListener("click", MiniCartWindowOnClick);
    };
    // ### UPDATE 2021

    var MiniCartWindowOnClick = function (e) {
      if (e.target.classList.contains("MiniCart--open")) {
        _collapseMiniCart();
      }
    };
    // ### UPDATE 2021

    var _unbindWindowListener = function () {
      document.body.removeEventListener("click", MiniCartWindowOnClick);
    };

    // ### UPDATE 2021
    var savedWalls = new WDN._Storage.Constructor(
      "ArtWalls", // Storage name
      {},
      {
        // expires: 7,
        type: "localstorage",
      }
    );

    // ### UPDATE 2021
    var _saveWall = function () {
      savedWalls.setEmptyStorage();
      savedWalls.add({ handle: JSON.stringify(Posters) });
    };

    // ### UPDATE 2021
    var _loadWall = function () {
      var save = JSON.parse(savedWalls.read())[0];
      var handles = [];
      if (save) {
        var data = JSON.parse(save.handle);
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            handles.push("handle:" + data[key].handle);
          }
        }
        _makeHandleSearch(handles);
      }
    };
    // ### UPDATE 2021
    var _artwallProducts, _artwallProductContent, _artwallProductJson;

    // ### UPDATE 2021
    var _makeHandleSearch = function (handles) {
      if (handles.length == 0) return;
      var query = handles.join(" OR ");
      var url = urlPrefix + "/search?view=artwall&type=product&q=" + query;
      WDN.RenderTemplate({
        url: url,
        target: "body",
        callback: function () {
          _assignScriptNodes();
          _updateLocalStorageData();
          _generateInstance();
          UpdateLayout();
          WDN.Poster.Posters = Posters;
        },
      });
    };

    var _assignScriptNodes = function () {
      _artwallProducts = document.querySelector("[data-artwall-products]");
      if (!_artwallProducts) return;
      _artwallProductContent = _artwallProducts.innerText;
      _artwallProductJson = JSON.parse(_artwallProductContent);
    };

    var _generateInstance = function () {
      var save = JSON.parse(savedWalls.read())[0];
      var data = JSON.parse(save.handle);
      Posters = {};

      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          for (var i in data[key].items) {
            if (data[key].items.hasOwnProperty(i)) {
              LastTopPos = data[key].items[i].lastTop;
              LastLeftPos = data[key].items[i].lastLeft;
              SidebarAddHandler({
                id: data[key].id,
                price: data[key].price,
                img: data[key].img,
                handle: data[key].handle,
                frame: data[key].items[i].frame,
                passepartout: data[key].items[i].passepartout,
                type: data[key].items[i].type,
                size: data[key].items[i].size,
                hasPosition: data[key].items[i].hasPosition,
              });
              Posters[data[key].id].title = data[key].title;
              Posters[data[key].id].vendor = data[key].vendor;
            }
          }
        }
      }
    };

    var _updateLocalStorageData = function () {
      var save = JSON.parse(savedWalls.read())[0];
      if (save) {
        var data = JSON.parse(save.handle);
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            for (var i in data[key].items) {
              if (data[key].items.hasOwnProperty(i)) {
                var updatedData = _getSearchVariantById(data[key].handle, data[key].items[i].variantId);
                _updateFrames(data[key].items);
                if (updatedData.product) {
                  data[key].price = updatedData.variant.price;
                  data[key].title = updatedData.product.title;
                  data[key].vendor = updatedData.product.vendor;
                  data[key].type = updatedData.product.type;
                  data[key].img = updatedData.variant.image;
                }
              }
            }
          }
        }
      }
      Posters = data;
      _saveWall();
    };

    var _updateFrames = function (items) {
      for (var key in items) {
        if (items.hasOwnProperty(key)) {
          if (items[key].frame.id) {
            var updatedFrame = GetFrameById(items[key].frame.id);
            items[key].frame.price = updatedFrame.price;
          }
        }
      }
    };
    var _getSearchVariantById = function (handle, id) {
      var foundVariant = false;
      var foundProduct = false;

      _artwallProductJson.forEach(function (product) {
        var _product = product[handle];
        if (_product) {
          _product.product.variants.forEach(function (variant) {
            if (variant[id]) {
              foundVariant = variant[id];
              foundProduct = _product.product;
            }
          });
        }
      });

      return { product: foundProduct, variant: foundVariant };
    };

    var _clearSave = function () {
      savedWalls.clear();
    };

    SearchHandler = function (e) {
      var searchData = e.target.value;
      var url = urlPrefix + "/search?q=" + searchData + "&view=template";
      if (searchData.length > 0) {
        WDN.Request.Get({
          url: url,
          onSuccess: function (res) {
            Nodes.searchGrid.innerHTML = res;
            HideCategories();
            Nodes.searchGrid.removeAttribute(Names.dataHidden);
            Bind.Sidebar();
          }.bind(this),
          onError: function () {
            console.log("error");
          },
        });
      }
      SelectSetPlaceholder();
    };

    SelectSetPlaceholder = function () {
      Nodes.navSelect.selectedIndex = 0;
    };

    Bind.Pagination = function () {
      var paginationPrevious = document.querySelectorAll(Selectors.paginationPrevious);
      var paginationNext = document.querySelectorAll(Selectors.paginationNext);

      if (paginationPrevious.length > 0) {
        paginationPrevious.forEach(function (previous) {
          previous.addEventListener("click", PaginationClickHandler);
        });
      }

      if (paginationNext.length > 0) {
        paginationNext.forEach(function (next) {
          next.addEventListener("click", PaginationClickHandler);
        });
      }
    };

    Bind.AddToCart = function () {
      Nodes.addToCart.addEventListener("click", AddToCartHandler);
    };

    Bind.Navigation = function () {
      Nodes.wishlist.addEventListener("click", WishlistHandler);
      Nodes.navSelect.addEventListener("change", SelectHandler);
    };

    SelectHandler = function () {
      var parent = document.querySelector(`${Selectors.productGridItem}[data-id="${this[this.selectedIndex].value}"]`);
      var main = document.querySelector(Selectors.sidebarGrid);
      main.removeAttribute(Names.dataHidden);
      if (!parent) {
        HideCategories();
        var url = urlPrefix + "/collections/" + this[this.selectedIndex].value + "?&view=postertemplate";
        WDN.Request.Get({
          url: url,
          onSuccess: function (res) {
            main.insertAdjacentHTML("beforeend", res);
            Bind.Sidebar();
          }.bind(this),
          onError: function () {
            console.log("error");
          },
        });
      } else {
        HideCategories();
        parent.removeAttribute(Names.dataHidden);
        Bind.Sidebar();
      }
    };

    HideCategories = function () {
      var categories = document.querySelectorAll(Selectors.productGridItem);

      categories.forEach(function (category) {
        category.setAttribute(Names.dataHidden, "");
      });

      Nodes.wishlistGrid.setAttribute(Names.dataHidden, "");
      Nodes.searchGrid.setAttribute(Names.dataHidden, "");
    };

    WishlistHandler = function () {
      Nodes.sidebarItems.forEach(function (item) {
        item.setAttribute(Names.dataHidden, "");
      });
      if (Nodes.wishlistGrid.dataset.rendered !== "") {
        RenderWishlistData();
      }
      Nodes.wishlistGrid.removeAttribute(Names.dataHidden);
      SelectSetPlaceholder();
    };

    RenderWishlistData = function () {
      var products = JSON.parse(WDN.PosterWishlist.Storage.read());
      var Output = [];
      var Items = [];

      if (products.length > 0) {
        products.forEach(function (product) {
          var url = `${urlPrefix}/products/${product.handle}?variant=${product.id}&view=wishlist`;
          WDN.Request.Get({
            url: url,
            onSuccess: function (res) {
              Output.push(res);
              Items.push({
                handle: product.handle,
                type: product.type,
                frameid: product.frame.id,
                passepartoutId: product.passepartout.id,
              });
              if (Output.length == products.length) {
                Nodes.wishlistGrid.innerHTML = Output.join("");
                RenderWishlistFramesAndPassepartouts(Items);
                Nodes.wishlistGrid.setAttribute("data-rendered", "");
                Bind.Sidebar();
              }
            },
            onError: function () {
              console.log("error");
              Output.push("");
            },
          });
        });
      } else {
        Nodes.wishlistGrid.innerHTML = `<p class="Poster__sidebar-wishlist--empty">${WDN.FrameTranslations.emptyWishlist}</p>`;
        Nodes.wishlistGrid.setAttribute("data-rendered", "");
      }
    };

    RenderWishlistFramesAndPassepartouts = function (items) {
      var Container = Nodes.wishlistGrid;
      for (var key in items) {
        var Found = false;
        if (items.hasOwnProperty(key)) {
          var item = items[key];
          // if item has frame
          var ItemContainer = Container.querySelector(`[data-handle="${item.handle}"]`);
          var ItemAdd = ItemContainer.querySelector(Selectors.sidebarAdd);

          if (item.frameid && item.frameid != "0") {
            var ItemFrame = ItemContainer.querySelector(".Poster__grid-frame");

            var FoundFrame = GetFrameById(item.frameid);
            var FrameImg = FoundFrame.images[item.type];
            ItemFrame.style.backgroundImage = `url(${FrameImg})`;
            ItemAdd.setAttribute("data-frameid", FoundFrame.id);
            ItemAdd.setAttribute("data-frameprice", FoundFrame.price);
          }
          if (item.passepartoutId) {
            var ItemPassepartout = ItemContainer.querySelector(".Poster__grid-passepartout");
            var selectedPassepartout = _getPassepartoutByVariantId(item.passepartoutId);
            var PassepartoutImg = _getPassepartoutImageByVariantIdAndType(item.passepartoutId, item.type);
            ItemPassepartout.style.backgroundImage = `url(${PassepartoutImg})`;
            ItemAdd.setAttribute("data-passepartoutid", item.passepartoutId);
            ItemAdd.setAttribute("data-passepartoutprice", selectedPassepartout.price);
            ItemContainer.setAttribute("data-has-passepartout", "");
          }
        }
      }
    };

    GetFrameById = function (id) {
      var Found = false;
      for (var frame in Frames) {
        if (Found) {
          break;
        }
        if (Frames.hasOwnProperty(frame)) {
          var frameVariants = Frames[frame].variants;
          for (variant in frameVariants) {
            if (frameVariants.hasOwnProperty(variant)) {
              if (frameVariants[variant].id == id) {
                Found = frameVariants[variant];
              }
            }
          }
        }
      }
      return Found;
    };

    CollectItems = function () {
      var Items = [];
      for (var key in Posters) {
        if (Posters.hasOwnProperty(key)) {
          var ids = parseInt(Posters[key].id);

          var frameId = false;
          var passepartoutId = false;

          for (var i in Posters[key].items) {
            if (Posters[key].items.hasOwnProperty(i)) {
              var bundle_id = Math.ceil(Math.random() * 100000);
              var _poster = Posters[key].items[i];
              // pushing frame
              if (_poster.frame.id) {
                frameId = parseFloat(_poster.frame.id);

                Items.push({
                  id: frameId,
                  quantity: 1,
                  properties: { _bundle_id: bundle_id, _origin: "artwall" },
                });
              }

              // pushing passepartout
              if (_poster.passepartout && _poster.passepartout.id) {
                passepartoutId = parseFloat(_poster.passepartout.id);

                Items.push({
                  id: passepartoutId,
                  quantity: 1,
                  properties: { _bundle_id: bundle_id, _origin: "artwall" },
                });
              }
              var productProps = {
                _origin: "artwall",
              };

              if (frameId || passepartoutId) {
                productProps._bundle_id = bundle_id;
              }

              Items.push({
                id: ids,
                quantity: 1,
                properties: productProps,
              });
            }
          }
        }
      }
      return Items;
    };

    AddToCartHandler = function (e) {
      e.preventDefault();
      if (Object.keys(Posters).length > 0) {
        Items = CollectItems();
        WDN.Cart.Add({
          data: {
            items: Items,
          },
          onSuccess: function (res) {
            if (typeof onAddToCart === "function") {
              WDN.Tracking.add_to_cart_artwall();
              onAddToCart(res);
            }
          },
          onError: function () {},
        });
      }
    };

    PaginationClickHandler = function (e) {
      e.preventDefault();
      var url = this.href + "&view=postertemplate";
      WDN.Request.Get({
        url: url,
        onSuccess: function (res) {
          Nodes.sidebarGrid.innerHTML = res;
          UpdateUrl(this.dataset.history);
          Bind.Sidebar();
        }.bind(this),
        onError: function () {
          console.log("error");
        },
      });
    };

    UpdateUrl = function (id) {
      if (typeof URLSearchParams !== "undefined") {
        var url = new URL(window.location.href);
        var searchParams = new URLSearchParams(url.search);
        var oldParam = window.location.href.split("?")[0].split("/");
        oldParam = oldParam[oldParam.length - 1] + "?";
        searchParams.set("page", id);
        window.history.pushState("", "", oldParam + searchParams);
      }
    };

    SidebarAddHandler = function (obj) {
      var id, price, img, handle, frame, passepartout, size, hasPosition;
      if (this.dataset) {
        id = this.dataset.id;
        price = this.dataset.price;
        img = this.dataset.img;
        handle = this.dataset.handle;
        type = this.dataset.type;
        size = this.dataset.size;
        frame = {
          id: this.dataset.frameid || false,
          price: this.dataset.frameprice || 0,
        };
        passepartout = {
          id: this.dataset.passepartoutid || false,
          price: this.dataset.passepartoutprice || 0,
        };
        hasPosition = false;
      } else {
        id = obj.id;
        price = obj.price;
        img = obj.img;
        handle = obj.handle;
        frame = obj.frame;
        passepartout = obj.passepartout;
        type = obj.type;
        size = obj.size;
        hasPosition = obj.hasPosition;
      }
      // checking if poster already exists
      if (Posters[id]) {
        // inserts new object into existing list
        // 0 is unique key, if its taken already it wil rerun the function
        // ### UPDATE 2021, PASSING HAS POSITION
        InsertInPoster(id, 0, frame, passepartout, type, size, hasPosition);
      } else {
        // creates new object for the first time
        var data = {
          id: id,
          price: price,
          img: img,
          handle: handle,
          frame: frame,
          passepartout: passepartout,
          type: type,
          size: size,
          hasPosition: hasPosition,
        };
        CreatePoster(data);
      }
      UpdateLayout();
      _saveWall();
    };

    InsertInPoster = function (id, newUnique, frame, passepartout, type, size, hasPosition) {
      // checking the count so we can create unique id
      var count = "" + Object.keys(Posters[id].items).length;
      newUnique ? (count = count + newUnique) : false;
      var uniqId = id + count;
      // if item with unique key exists
      if (Posters[id].items[uniqId]) {
        !newUnique ? (newUnique = 0) : false;
        newUnique = newUnique + 1;
        // if item with the key exists call function again with new key
        // ### UPDATE 2021, PASSING HAS POSITION
        InsertInPoster(id, newUnique, frame, passepartout, type, size, hasPosition);
      } else {
        LastUniqe = uniqId;
        LastVariant = id;
        // ### UPDATE 2021, PASSING HAS POSITION
        var newObj = new Poster(uniqId, id, frame, passepartout, type, size, hasPosition);
        Posters[id].items[uniqId] = newObj;
      }
    };

    CreatePoster = function (product) {
      CreateInstance(product);
    };

    UpdatePrice = function () {
      var sum = 0;
      // ### UPDATE 2021

      for (var key in Posters) {
        if (Posters.hasOwnProperty(key)) {
          var price = parseInt(Posters[key].price);
          var count = Object.keys(Posters[key].items).length;
          for (var i in Posters[key].items) {
            if (Posters[key].items.hasOwnProperty(i)) {
              var _poster = Posters[key].items[i];
              sum += parseFloat(_poster.frame.price);
              if (_poster.passepartout) {
                sum += parseFloat(_poster.passepartout.price || 0);
              }
            }
          }
          sum += price * count;
        }
      }

      Nodes.price.innerHTML = WDN.Money.Format(sum);
    };

    CreateInstance = function (variant, img, handle, type, size) {
      Posters[variant.id] = {};
      Posters[variant.id].id = variant.id;
      Posters[variant.id].price = variant.price;
      Posters[variant.id].img = variant.img || img;
      Posters[variant.id].handle = variant.handle || handle;
      Posters[variant.id].type = variant.type || type;
      Posters[variant.id].size = variant.size || size;
      Posters[variant.id].hasPosition = variant.hasPosition || false;
      Posters[variant.id].items = {};
      var uniqId = variant.id + "0";
      LastUniqe = uniqId;
      LastVariant = variant.id;
      
      var newObj = new Poster(
        uniqId,
        variant.id,
        variant.frame,
        variant.passepartout,
        variant.type,
        variant.size,
        variant.hasPosition
      );
      Posters[variant.id].items[uniqId] = newObj;
    };

    Poster = function (id, variantId, frame, passepartout, type, size, hasPosition) {
      this.id = id;
      this.variantId = variantId;
      this.frame = frame;
      this.passepartout = passepartout || {};
      this.type = type;
      this.size = size;
      this.hasPosition = hasPosition;
      this.createHTML();
      this.bind();
    };

    Poster.prototype.createHTML = function () {
      var item = this.createItem();
      var removeBtn = this.createRemove();
      var moveIcon = this.createMove();
      var bg = document.createElement("div");
      //# 2022 update
      var passepartoutbg = document.createElement("div");
      passepartoutbg.classList.add("Poster__preview-passepartout");

      if (this.passepartout && this.passepartout.id) {
        var image = _getPassepartoutImageByVariantIdAndType(this.passepartout.id, this.type);
        passepartoutbg.style.backgroundImage = `url(${image || ""})`;
      }

      bg.style.backgroundImage = `url(${Posters[this.variantId].img})`;
      bg.classList.add("Poster__preview-background");

      passepartoutbg.setAttribute("data-poster-passepartout", "");

      item.insertAdjacentElement("beforeend", bg);
      item.insertAdjacentElement("beforeend", passepartoutbg);
      item.insertAdjacentElement("beforeend", removeBtn);
      item.insertAdjacentElement("beforeend", moveIcon);
      Nodes.background.insertAdjacentElement("beforeend", item);
      this.item = item;
      this.frameBg = this.item.querySelector(Selectors.previewFrame);
      this.passepartoutBg = this.item.querySelector("[data-poster-passepartout]");

      item.dataset.hasFrame = "no";
      item.dataset.hasPassepartout = "no";

      if (this.frame.id) {
        var frame = GetFrameById(this.frame.id);
        this.frameBg.style.backgroundImage = `url(${frame.images[this.type]})`;
        item.dataset.hasFrame = "yes";
      }

      if (this.passepartout && this.passepartout.id) {
        // logic for getting passepartout image here
        item.dataset.hasPassepartout = "yes";
      }

      this.assignSize();
      this.move = moveIcon;
      this.remove = removeBtn;
    };

    Poster.prototype.assignSize = function () {
      switch (this.type) {
        case "overlay_kvadratisk":
          this.item.setAttribute("data-type", "square");
          break;
        case "overlay_landskab":
          this.item.setAttribute("data-type", "landscape");
          break;
        case "overlay_portræt":
          this.item.setAttribute("data-type", "portrait");
          break;
      }
    };

    Poster.prototype.createMove = function () {
      var item = document.createElement("button");
      var adjustIcon = document.createElement("img");
      adjustIcon.src = WDN.FrameIcons.adjust;
      item.classList.add("Poster__preview-item--move");
      item.insertAdjacentElement("beforeend", adjustIcon);
      return item;
    };

    Poster.prototype.createItem = function () {
      var item = document.createElement("div");
      var frame = document.createElement("div");
      frame.classList.add(Names.previewFrame);
      item.classList.add("Poster__preview-item");
      item.dataset.id = this.id;
      item.dataset.size = this.size;
      item.insertAdjacentElement("beforeend", frame);
      this.setPosition(item);
      return item;
    };

    Poster.prototype.setPosition = function (item) {
      if (this.hasPosition) {
        // uses the position of previous instance
        item.style.top = LastTopPos;
        item.style.left = LastLeftPos;
        this.lastTop = LastTopPos;
        this.lastLeft = LastLeftPos;
      } else {
        // sets position for the first time, default 50%
        item.style.top = "50%";
        item.style.left = "50%";
      }
    };

    Poster.prototype.createRemove = function () {
      var removeBtn = document.createElement("button");
      var removeIcon = document.createElement("img");
      removeBtn.classList.add("Poster__preview-item--remove");
      removeIcon.src = WDN.FrameIcons.delete;
      removeBtn.insertAdjacentElement("beforeend", removeIcon);
      return removeBtn;
    };

    Poster.prototype.bind = function () {
      this.pos1 = 0;
      this.pos2 = 0;
      this.pos3 = 0;
      this.pos4 = 0;
      this.move.onmousedown = this.mouseDownHandler.bind(this);
      this.remove.addEventListener("click", this.removeHandler.bind(this));
      this.item.addEventListener("click", this.itemHandler.bind(this));
    };

    Poster.prototype.itemHandler = function (e) {
      if (e.target.classList.contains(Names.previewFrame)) {
        // stores Last data in case we do changes
        this.storeData();
        var drawer = WDN.Drawer.List["frame"];
        drawer.onClose = function () {
          DrawerAdjust(this.drawer, "-100%");
        };

        if (drawer.state == "closed") {
          SetLoading();
          drawer.open();
          // calculates sidebar width and uses it to open a drawer
          DrawerAdjust(drawer.drawer);
          this.populateDrawer();
        } else {
          drawer.close();
          // closes drawer by translateX -100%
          DrawerAdjust(drawer.drawer, "-100%");
        }
        _saveWall();
      }
    };

    DrawerAdjust = function (drawer, pos) {
      var sidebarWidth = Nodes.sidebar.offsetWidth;
      if (pos === "-100%") {
        sidebarWidth = sidebarWidth * -1;
      }

      drawer.style.left = pos || sidebarWidth + "px";

    };

    Poster.prototype.storeData = function () {
      LastUniqe = this.id;
      LastVariant = this.variantId;
      LastTopPos = this.item.style.top;
      LastLeftPos = this.item.style.left;
    };

    Poster.prototype.populateDrawer = function () {
      var url =
        urlPrefix +
        "/products/" +
        Posters[this.variantId].handle +
        "?variant=" +
        this.variantId +
        "&view=postertemplate";
      WDN.Request.Get({
        url: url,
        onSuccess: function (res) {
          Nodes.frameDrawer.innerHTML = res;
          this.configureSelect();
          if (this.passepartout && this.passepartout.id) {
            this.setPassepartout(this.passepartout.id);
          }
          this.setFrame(this.frame.id);
          // ### UPDATE 2021
          this.updatePrice();
          ClearLoading();
        }.bind(this),
        onError: function () {
          console.log("error");
        },
      });
    };

    SetLoading = function () {
      var container = document.querySelector(".Poster__loading-wrapper");
      container.removeAttribute(Names.dataHidden);
    };

    ClearLoading = function () {
      var container = document.querySelector(".Poster__loading-wrapper");
      container.setAttribute(Names.dataHidden, "");
    };

    GetSelectedProduct = function () {
      return document.querySelector("wdn-variant-select").data.selected_variant.data.title;
      // aug22 update
      var selectId = document.querySelector(".Select").dataset.id;
      return WDN.Select.List[selectId].currentOption.value;
    };

    var UpdateLayout = function () {
      UpdatePrice();
      UpdateMiniCart();
    };

    var UpdateMiniCart = function () {
      var items = CollectItems();
      _updateMiniCartCount(items);
      _updateMiniCartItems();
    };

    var _updateMiniCartCount = function (items) {
      if (Nodes.miniCartCount) {
        var sum;
        if (items.length > 0) {
          var totalQuantity = [];
          items.forEach(function (item) {
            totalQuantity.push(item.quantity);
          });
          sum = totalQuantity.reduce((a, b) => a + b);
        } else {
          sum = 0;
        }

        Nodes.miniCartWrapper.dataset.minicart = sum;
        Nodes.miniCartCount.innerHTML = sum;
      }
    };

    var _updateMiniCartItems = function () {
      var items = Posters;
      var templatedItems = [];
      for (var key in items) {
        if (items.hasOwnProperty(key)) {
          templatedItems.push(_templateMiniCartItem(items[key]));
        }
      }
      Nodes.miniCartItems.innerHTML = templatedItems.join("");
    };

    var _templateMiniCartItem = function (item) {
      var quantity = Object.keys(item.items).length;
      if (!item.title) {
        var title = _getMiniCartTitle(item.handle);
      } else {
        var title = item.title;
      }
      if (!item.vendor) {
        var vendor = _getMiniCartVendor(item.handle);
      } else {
        var vendor = item.vendor;
      }
      var frames = _getMiniCartFrames(item.items);
      var passepartouts = _getMiniCartPassepartouts(item.items);
      item.vendor = vendor;
      item.title = title;
      var Item = _miniCartItemGetHtml(item.img, title, vendor, item.price);
      return Item.repeat(quantity) + frames + passepartouts;
    };

    var _miniCartItemGetHtml = function (image, title, vendor, price) {
      return `<div class="MiniCart__item">
      <div class="MiniCart__item-image">
      <img src="${image}">
      </div>
      <div class="MiniCart__item-text">
      <p class="MiniCart__item-title">${title}</p>
      <p class="MiniCart__item-vendor">${vendor}</p>
      <p class="MiniCart__item-price">${WDN.Money.Format(price)}</p>
      </div>
      </div>`;
    };

    var _getMiniCartFrames = function (items) {
      var frames = [];
      for (var key in items) {
        if (items.hasOwnProperty(key)) {
          if (items[key].frame.id) {
            var item = GetFrameById(items[key].frame.id);
            var title = item.frame_title;
            var frameimg = item.images[items[key].type];
            var vendor = item.frame_vendor;
            var frame = _miniCartItemGetHtml(frameimg, title, vendor, item.price);
            frames.push(frame);
          }
        }
      }
      return frames.join("");
    };

    var _getMiniCartPassepartouts = function (items) {
      var passepartouts = [];

      for (var key in items) {
        if (items.hasOwnProperty(key)) {
          if (items[key].passepartout) {
            var item = _getPassepartoutByVariantId(items[key].passepartout.id);
          }
          if (item) {
            var title = item.name;
            var image = _getPassepartoutImageByVariantIdAndType(item.id, items[key].type);
            var vendor = "";
            var passepartout = _miniCartItemGetHtml(image, title, vendor, item.price);
            passepartouts.push(passepartout);
          }
          //
        }
      }

      return passepartouts.join("");
    };

    var _getMiniCartTitle = function (handle) {
      var container = document.querySelector(`.Poster__product--grid-item[data-handle='${handle}']`);
      if (container) {
        var title = container.querySelector(".Poster__grid-title").innerText;
      }
      return title;
    };

    var _getMiniCartVendor = function (handle) {
      var container = document.querySelector(`.Poster__product--grid-item[data-handle='${handle}']`);
      if (container) {
        var vendor = container.querySelector(".Poster__grid-vendor").innerText;
      }
      return vendor;
    };

    // aug22 update
    Poster.prototype.setPassepartout = function (passepartout) {
      var passepartoutSelect = document.querySelector("wdn-passepartout-select");
      var selectedPassepartout = passepartoutSelect.get_related_passepartout_by_variant_id(passepartout);
      if (!selectedPassepartout) return;

      var selectedColor = selectedPassepartout.name.split(" - ")[1];
      passepartoutSelect.select_option_by_value(selectedColor);
    };

    Poster.prototype.setFrame = function (frame) {
      if (!frame) return;
      var selected = GetSelectedProduct();
      var frameSelect = document.querySelector("wdn-frame-select");
      var foundFrame = frameSelect.get_frame_by_id(frame);

      if (!foundFrame) return;
      var frameValue = foundFrame.name.split(" - ")[0];
      frameSelect.select_option_by_value(frameValue);
      return; // aug22 update
      var selectedFrame = WDN.Select.List["frameSelect"].currentOption.value;
      this.updateFrame(Frames[selectedFrame].variants[selected]);
    };

    Poster.prototype.handlePosterChange = function (e) {
      var variantSelect = e.currentTarget;
      var selectedVariant = variantSelect.get_selected_variant();
      if (!selectedVariant) return;
      var passepartoutSelect = document.querySelector("wdn-passepartout-select");
      var selectedPassepartout = passepartoutSelect.get_selected_passepartout_variant();

      var frameSelect = document.querySelector("wdn-frame-select");
      var selectedFrame = frameSelect.get_frame_variant();

      var instance = Posters[LastVariant];
      //  var frame = instance.items[LastUniqe].frame;
      //  var passepartout = instance.items[LastUniqe].passepartout;
      var obj = {
        id: selectedVariant.id,
        img: instance.img,
        price: selectedVariant.price,
        handle: instance.handle,
        frame: {
          id: selectedFrame ? selectedFrame.id : false,
          price: selectedFrame ? selectedFrame.price : 0,
        },
        passepartout: {
          id: selectedPassepartout ? selectedPassepartout.id : false,
          price: selectedPassepartout ? selectedPassepartout.price : 0,
          bg: passepartoutSelect.data.selected_product ? passepartoutSelect.data.selected_product.image : "",
        },
        type: instance.type,
        size: selectedVariant.option1,
        hasPosition: true,
      };

      this.removePreviousInstance();

      // creating the new instance
      SidebarAddHandler(obj);

      this.updatePassepartout(selectedPassepartout);

      // moving passepartout settings from previous instance to newly created one
      MigratePassepartoutSettings(selectedVariant);

      // moving frame settings from previous instance to newly created one
      MigrateFrameSettings(selectedVariant);

      // re-rendering the drawer with different frame settings suitable for the image size
      Posters[LastVariant].items[LastUniqe].populateDrawer();
      _saveWall();
    };

    Poster.prototype.handleFrameChange = function (e) {
      var selectData = e.currentTarget.data;
      var selectedFrameProduct = Frames[selectData.selected_product.title];

      if (selectedFrameProduct) {
        var selectedFrameVariant = selectedFrameProduct.variants[selectData.poster_size];
      }
      this.updateFrame(selectedFrameVariant);
      this.updatePrice();
      _saveWall();
    };

    Poster.prototype.handlePassepartoutChange = function (e) {
      var passepartoutSelect = e.currentTarget;
      var selectedPassepartout = passepartoutSelect.get_selected_passepartout_variant();
      this.updatePassepartout(selectedPassepartout);
      this.updatePrice();
      _saveWall();
      // Posters[LastVariant].items[LastUniqe]
    };

    Poster.prototype.configureSelect = function () {
      var poster_select = document.querySelector("wdn-variant-select");
      var frame_select = document.querySelector("wdn-frame-select");
      var passepartout_select = document.querySelector("wdn-passepartout-select");

      poster_select.addEventListener("change", this.handlePosterChange.bind(this));
      frame_select.addEventListener("change", this.handleFrameChange.bind(this));
      passepartout_select.addEventListener("change", this.handlePassepartoutChange.bind(this));

      return; // aug22 update
      this.removeSelects();
      this.populateFrameSelect();
      WDN.Select.Init();
      var _this = this;

      WDN.Select.List["frameSelect"].callback = function () {
        var frame = Frames[this.currentOption.value];
        if (frame) {
          var selected = GetSelectedProduct();
          _this.updateFrame(frame.variants[selected]);
        } else {
          _this.updateFrame(false);
        }
        // ### UPDATE 2021
        _this.updatePrice();
        _saveWall();
      };

      WDN.Product_select.Init({
        onChange: function (variant) {
          var instance = Posters[LastVariant];
          var frame = instance.items[LastUniqe].frame;
          // frame id returns id or false
          _this.setFrame(frame.id);
          var obj = {
            id: variant.id,
            img: instance.img,
            price: variant.price,
            handle: instance.handle,
            frame: frame,
            type: instance.type,
            size: variant.option1,
            hasPosition: true,
          };

          this.removePreviousInstance();

          // creating the new instance
          SidebarAddHandler(obj);

          // moving frame settings from previous instance to newly created one
          MigrateFrameSettings(variant);

          // re-rendering the drawer with different frame settings suitable for the image size
          Posters[LastVariant].items[LastUniqe].populateDrawer();
          _saveWall();
        }.bind(this),
      });
    };

    var MigratePassepartoutSettings = function (variant) {
      var passepartoutSelect = document.querySelector("wdn-passepartout-select");
      var selectedPassepartout = passepartoutSelect.get_selected_passepartout_variant();
      var passepartoutValue = false;
      if (selectedPassepartout) {
        passepartoutValue = "";
      }
    };

    var MigrateFrameSettings = function (variant) {
      var frameSelect = document.querySelector("wdn-frame-select");
      var selectedFrame = frameSelect.data.selected_option.value;
      var frameValue = false;
      if (selectedFrame !== "null") {
        frameValue = Frames[selectedFrame].variants[variant.option1];
      }
      Posters[LastVariant].items[LastUniqe].updateFrame(frameValue);
      return; // aug22 update
      var selectedFrame = WDN.Select.List["frameSelect"].currentOption.value;

      if (selectedFrame !== "false") {
        Posters[LastVariant].items[LastUniqe].updateFrame(Frames[selectedFrame].variants[variant.option1]);
      }
    };

    Poster.prototype.removePreviousInstance = function () {
      var itemsLength = Object.keys(Posters[LastVariant].items).length;
      Posters[LastVariant].items[LastUniqe].item.remove();
      if (itemsLength == 1) {
        delete Posters[LastVariant];
      } else {
        delete Posters[LastVariant].items[LastUniqe];
      }
    };

    Poster.prototype.updatePassepartout = function (passepartout) {
      var passepartoutSelect = document.querySelector("wdn-passepartout-select");
      var currentItem = Posters[LastVariant].items[LastUniqe];

      currentItem.passepartout.id = passepartout ? passepartout.id : false;
      currentItem.passepartout.price = passepartout ? passepartout.price : 0;
      var image_src = "";
      if (passepartout) {
        image_src = passepartoutSelect.data.selected_product.image;
        currentItem.item.dataset.hasPassepartout = "yes";
      } else {
        currentItem.item.dataset.hasPassepartout = "no";
      }

      this.setPassepartoutBg(currentItem, image_src);
      UpdateLayout();
    };

    Poster.prototype.updateFrame = function (frame) {
      var currentItem = Posters[LastVariant].items[LastUniqe];
      currentItem.frame.id = frame ? frame.id : false;
      currentItem.frame.price = frame ? frame.price : 0;
      // if theres frame and frame for specific size
      if (frame && frame.images[this.type]) {
        this.setFrameBg(currentItem, frame.images[this.type]);
        currentItem.item.dataset.hasFrame = "yes";
      } else {
        currentItem.item.dataset.hasFrame = "no";
        this.setFrameBg(currentItem, "");
      }

      UpdateLayout();
    };

    // ### UPDATE 2021
    Poster.prototype.updatePrice = function () {
      var priceContainer = document.querySelector("[data-drawer-sum]");
      var framePrice = parseFloat(this.frame.price);
      var variantPrice = parseFloat(Posters[this.variantId].price);
      var passepartoutPrice = this.passepartout ? parseFloat(this.passepartout.price) : 0;

      priceContainer.innerHTML = WDN.Money.Format(framePrice + variantPrice + passepartoutPrice);
    };

    // aug22 update
    Poster.prototype.setPassepartoutBg = function (currentItem, src) {
      var passepartoutItem = currentItem.item.querySelector(Selectors.previewPassepartout);
      passepartoutItem.style.backgroundImage = `url(${src})`;
    };

    Poster.prototype.setFrameBg = function (currentItem, src) {
      var FrameContainer = document.querySelector(Selectors.frameContainer);
      var FrameItem = currentItem.item.querySelector(Selectors.previewFrame);
      FrameContainer.style.backgroundImage = `url(${src})`;
      FrameItem.style.backgroundImage = `url(${src})`;
    };

    Poster.prototype.populateFrameSelect = function () {
      var Select = document.querySelector(".Select[data-id='frameSelect']");
      if (!Select) return; // aug22 update
      var container = Select.querySelector(".Select__dropdown-container");
      var Content = [];
      var FoundCount = 0;
      for (var key in Frames) {
        var Found = false;
        if (Frames.hasOwnProperty(key)) {
          var variant = Frames[key].variants[this.size];
          if (variant && variant.available == "true") {
            if (variant.id == this.frame.id) {
              Found = true;
              FoundCount = 1;
            }
            if (Found) {
              // params - value, is-placeholder, is-active
              Content.push(TemplateOption(key, false, true));
            } else {
              Content.push(TemplateOption(key, false, false));
            }
          }
        }
      }
      if (FoundCount > 0) {
        // templating label (placeholder)
        Content.push(TemplateOption(WDN.FrameTranslations.placeholder, true, false));
      } else {
        Content.push(TemplateOption(WDN.FrameTranslations.placeholder, true, true));
      }

      container.innerHTML = Content.join("");
    };

    TemplateOption = function (value, isPlaceholder, isActive) {
      if (isPlaceholder) {
        return `<div class="Select__option${
          isActive ? " Select__option--active" : ""
        }" data-option="false" data-value="false"><span class="Select__label">${value}</span></div>`;
      } else {
        return `
<div class="Select__option${
          isActive ? " Select__option--active" : ""
        }" data-option="${value}" data-value="${value}"><span class="Select__label">${value}</span></div>`;
      }
    };

    Poster.prototype.removeSelects = function () {
      for (var key in WDN.Select.List) {
        if (WDN.Select.List.hasOwnProperty(key)) {
          delete WDN.Select.List[key];
        }
      }
    };

    Poster.prototype.removeHandler = function () {
      var PostersLength = Object.keys(Posters[this.variantId].items).length;
      this.item.remove();
      if (PostersLength == 1) {
        // delete whole object
        delete Posters[this.variantId];
      } else {
        // delete just the item
        delete Posters[this.variantId].items[this.id];
      }
      // ### UPDATE 2021
      WDN.Drawer.List.frame.close();

      UpdateLayout();
      _saveWall();
    };

    Poster.prototype.mouseDownHandler = function (e) {
      e = e || window.event;
      e.preventDefault();
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      document.onmouseup = this.unbindElement.bind(this);
      document.onmousemove = this.dragElement.bind(this);
    };

    Poster.prototype.dragElement = function (e) {
      e = e || window.event;
      e.preventDefault();
      this.hasPosition = true;
      this.pos1 = this.pos3 - e.clientX;
      this.pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      // ### UPDATE 2021
      this.lastTop = this.item.offsetTop - this.pos2 + "px";
      this.lastLeft = this.item.offsetLeft - this.pos1 + "px";
      this.item.style.top = this.lastTop;
      this.item.style.left = this.lastLeft;
    };

    Poster.prototype.unbindElement = function () {
      document.onmouseup = null;
      document.onmousemove = null;
      _saveWall();
    };

    var onAddToCart = false;
    Init = function (callback) {
      Bind.Navigation();
      Bind.Sidebar();
      Bind.Search();
      Bind.BackgroundToggle();
      Bind.AddToCart();
      Bind.MiniCart();
      callback ? (onAddToCart = callback.onAddToCart) : "";
      _preloadImages();
    };

    if (typeof WDN.Background === "undefined") {
      WDN.Background = (function () {
        Names.backgroundItem = "Background__grid-item";
        Selectors.backgroundItem = `.${Names.backgroundItem}`;
        Nodes.backgroundItems = document.querySelectorAll(Selectors.backgroundItem);

        Nodes.backgroundBack = document.querySelector(".Poster__background");
        Nodes.backgroundFront = document.querySelector(".Poster__background-front");

        var Init, Background, ClearOtherSelects;

        var BgList = {};

        Background = function (item, index) {
          this.id = index;
          this.item = item;
          this.backImage = item.dataset.back;
          this.frontImage = item.dataset.front;
          this.bind();
        };

        Background.prototype.bind = function () {
          this.item.addEventListener("click", this.itemHandler.bind(this));
        };

        Background.prototype.itemHandler = function () {
          ClearOtherSelects();
          this.item.setAttribute("data-selected", "");
          Nodes.backgroundFront.style.backgroundImage = `url(${this.frontImage})`;
          Nodes.backgroundBack.style.backgroundImage = `url(${this.backImage})`;
        };

        ClearOtherSelects = function () {
          Nodes.backgroundItems.forEach(function (background) {
            background.removeAttribute("data-selected");
          });
        };

        var targ = document.querySelector(".Poster__background");
        targ.addEventListener("click", function () {
          var drawer = WDN.Drawer.List["frame"];
          var bgDrawer = WDN.Drawer.List["background"];
          drawer.close();
          bgDrawer.close();
        });

        Init = function () {
          if (Nodes.backgroundItems.length > 0) {
            Nodes.backgroundItems.forEach(function (background, i) {
              BgList[i] = new Background(background, i);
            });
          }
          _loadWall();
        };

        Init();
        return {};
      })();
    }

    return {
      Posters: Posters,
      Init: Init,
      Save: _saveWall,
      ClearSave: _clearSave,
      Load: _loadWall,
      SavedWalls: savedWalls,
    };
  })();
}

WDN.Poster.Init({
  onAddToCart: function (res) {
    document.dispatchEvent(
      new CustomEvent("product:added", {
        bubbles: false,
        detail: {
          variant: 1234, // random
          quantity: 1,
        },
      })
    );
  },
});

WDN.Drawer.List["frame"].drawer.style.left = "-100%";
WDN.Drawer.List["background"].drawer.style.left = "-100%";
